// extracted by mini-css-extract-plugin
module.exports = {"onHoldContainer":"membershipbadge_onHoldContainer__1lNm2","obliqueLineWrap":"membershipbadge_obliqueLineWrap__2xXLz","obliqueLine":"membershipbadge_obliqueLine__1gOyQ"};